// ** React Imports
import {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useState
} from 'react';
import PropTypes from 'prop-types';

import '../../core/components/ripple-button';
import '../../core/scss/react/libs/react-hot-toasts/react-hot-toasts.scss';
// import '../../core/scss/core.scss';
// import '../../assets/scss/style.scss';
import defaultThemeConfig from '../../../config/themeConfig';

// ** Create Context
const ThemeColors = createContext({});

function ThemeContext({
  children,
  themeConfig = {
    layout: {
      isRTL: false,
      skin: 'light', // light, dark, bordered, semi-dark
      type: 'vertical', // vertical, horizontal
      contentWidth: 'full', // full, boxed
      menu: {
        isHidden: false,
        isCollapsed: false
      },
      navbar: {
        // ? For horizontal menu, navbar type will work for navMenu type
        type: 'floating', // static , sticky , floating, hidden
        backgroundColor: 'white' // BS color options [primary, success, etc]
      },
      footer: {
        type: 'static' // static, sticky, hidden
      },
      customizer: false,
      scrollTop: true, // Enable scroll to top button
      toastPosition: 'top-right' // top-left, top-center, top-right, bottom-left, bottom-center, bottom-right
    },
    images: {}
  }
}) {
  // ** State
  const [colors, setColors] = useState({});

  //* * ComponentDidMount
  useEffect(() => {
    if (window !== 'undefined') {
      //* * Get variable value
      const getHex = (color) => (
        window.getComputedStyle(document.body).getPropertyValue(color).trim()
      );

      //* * Colors obj
      const obj = {
        primary: {
          light: getHex('--bs-primary').concat('1a'),
          main: getHex('--bs-primary')
        },
        secondary: {
          light: getHex('--bs-secondary').concat('1a'),
          main: getHex('--bs-secondary')
        },
        success: {
          light: getHex('--bs-success').concat('1a'),
          main: getHex('--bs-success')
        },
        danger: {
          light: getHex('--bs-danger').concat('1a'),
          main: getHex('--bs-danger')
        },
        warning: {
          light: getHex('--bs-warning').concat('1a'),
          main: getHex('--bs-warning')
        },
        info: {
          light: getHex('--bs-info').concat('1a'),
          main: getHex('--bs-info')
        },
        dark: {
          light: getHex('--bs-dark').concat('1a'),
          main: getHex('--bs-dark')
        }
      };

      setColors({ ...obj });
    }
  }, []);

  const value = useMemo(() => ({
    colors,
    themeConfig: themeConfig || defaultThemeConfig
  }), [colors, themeConfig]);

  return (
    <ThemeColors.Provider value={value}>{children}</ThemeColors.Provider>
  );
}

ThemeContext.propTypes = {
  children: PropTypes.node.isRequired,
  themeConfig: PropTypes.object
};

export const useThemeContext = () => useContext(ThemeColors);

export { ThemeColors, ThemeContext };
